import * as React from 'react';

const Printer24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7.25 2C6.56 2 6 2.56 6 3.25v3H4.75A2.75 2.75 0 0 0 2 9v6.25A2.75 2.75 0 0 0 4.75 18H6v2.75c0 .69.56 1.25 1.25 1.25h9.5c.69 0 1.25-.56 1.25-1.25V18h1.25A2.75 2.75 0 0 0 22 15.25V9a2.75 2.75 0 0 0-2.75-2.75H18v-3C18 2.56 17.44 2 16.75 2zm9.25 4.25h-9V3.5h9zM4.75 7.75h14.5c.69 0 1.25.56 1.25 1.25v6.25c0 .69-.56 1.25-1.25 1.25H18v-2.75c0-.69-.56-1.25-1.25-1.25h-9.5c-.69 0-1.25.56-1.25 1.25v2.75H4.75c-.69 0-1.25-.56-1.25-1.25V9c0-.69.56-1.25 1.25-1.25M7.5 14h9v6.5h-9z"
  }
));
Printer24.Size = 24;
Printer24.Title = "Printer";

export { Printer24 as default };
